import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataLocalStorageService{
    saveIdSolicitudPendRevisar(idSolicitudPend : String){
        localStorage.setItem('idSolicitudPendRevisar', JSON.stringify(idSolicitudPend));
    }

    getIdSolicitudPendRevisar(){
        return JSON.parse(localStorage.getItem('idSolicitudPendRevisar'));
    }

    deleteIdSolicitudPendRevisar(){
        localStorage.removeItem('idSolicitudPendRevisar');
    }

    saveIdSolicitudPendAprobar(idSolicitudAprob : String){
        localStorage.setItem('idSolicitudPendAprobar', JSON.stringify(idSolicitudAprob));
    }

    getIdSolicitudPendAprobar(){
        return JSON.parse(localStorage.getItem('idSolicitudPendAprobar'));
    }

    deleteIdSolicitudPendAprobar(){
        localStorage.removeItem('idSolicitudPendAprobar');
    }

    saveIdSolicitudPendHome(idSolicitudHome : String){
        localStorage.setItem('idSolicitudPendHome', JSON.stringify(idSolicitudHome));
    }

    getIdSolicitudPendHome(){
        return JSON.parse(localStorage.getItem('idSolicitudPendHome'));
    }

    deleteIdSolicitudPendHome(){
        localStorage.removeItem('idSolicitudPendHome');
    }
}